import {
  AssetRoutineState,
  FeatureName,
  RoutineWorkflow,
  Severity,
  useIsFeatureEnabled,
  WorkspaceRoutine,
} from '@gripp/shared-logic';
import { ReactNode } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { RoutineModules } from '../routineModules';
import { RoutineModule } from '../types';
import { RoutineModuleButtonOld } from './routineModuleButton-old';

type RoutineModuleButtonProps = {
  routine: WorkspaceRoutine;
  state?: AssetRoutineState<any>;
  buttonIndex: number;
  buttonCount: number;
  buttonStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  buttonIcon?: Severity;
  buttonIconStyle?: StyleProp<ViewStyle>;
  secondaryButtonIcon?: ReactNode;
  leftButtonIcon?: ReactNode;
  workflows?: RoutineWorkflow[];
  onClick: (
    routine: WorkspaceRoutine,
    module: RoutineModule<any, any>,
    state?: AssetRoutineState<any>,
    additionalState?: any,
    workflows?: RoutineWorkflow[]
  ) => void;
};


export const RoutineModuleButton = (props: RoutineModuleButtonProps) => {
  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign: Remove old Routine Buttons after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <RoutineModuleButtonOld {...props} />;
  }

  // TODO: Crop Circle Redesign: Remove to RoutineModuleButtonBase after feature is fully rolled out
  return (
    <RoutineModuleButtonBase {...props} />
  )
};

export const RoutineModuleButtonBase = (props: RoutineModuleButtonProps) => {
  const module = props.routine.type ? RoutineModules[props.routine.type] : undefined;
  const ModuleButtons = module?.buttons;
  
  if (!ModuleButtons) return null;

  return (
    <View
      key={props.routine.id}
      style={{ marginBottom: 8 }}
    >
      <ModuleButtons
        key={props.routine.id}
        config={props.routine.config}
        currentState={props.state}
        styleOverrides={{
          buttonStyle: props.buttonStyle,
          labelStyle: props.labelStyle,
          buttonIcon: props.buttonIcon,
          buttonIconStyle: props.buttonIconStyle,
          secondaryButtonIcon: props.secondaryButtonIcon,
          leftButtonIcon: props.leftButtonIcon,
        }}
        onClick={async (additionalState: any) =>
          await props.onClick(
            props.routine,
            module,
            props.state,
            additionalState,
            props.workflows
          )
        }
      />
    </View>
  );
};
